<div class="tab-container">
  <div class="actions">
    <app-button (btnClick)="downloadReport()" styleType="outlined" icon="pi pi-download">
      Baixar Relatório
    </app-button>
  </div>
  <app-validated-reports-section />
  <app-check-in-section [eventId]="eventId" />
</div>
